/* eslint-disable max-len */
import EaCalculator from '@propertypal/shared/src/resources/icons/products/ea-calculator-icon.svg';
import EaConsultancy from '@propertypal/shared/src/resources/icons/products/ea-consultancy-icon.svg';
import EaConsultancy1 from '@propertypal/shared/src/resources/icons/products/ea-consultancy-icon1.svg';
import EaWhyTraffic from '@propertypal/shared/src/resources/icons/products/why-traffic-icon.svg';
import Mockup from '@propertypal/shared/src/resources/images/specialist-consultancy/consultancy.jpg';
import React from 'react';
import { useTheme } from 'styled-components';
import Button from '../buttons/Button';
import ProductsPageHeader, { ProcutsHeaderIcon } from '../headers/products/ProductsPageHeader';
import { Box } from '../layout';
import { Bold, Text } from '../typography';
import { ButtonContainer } from './ProductScreenTabs.style';
import {
  FeaturesContainer,
  FeaturesSectionBgImage,
  FeaturesSectionContainer,
  FeaturesSectionTitle,
  FeaturesWrapper,
} from './ProductsFeatures.style';

const icons: ProcutsHeaderIcon[] = [
  {
    SVG: EaConsultancy1,
    heading: 'Understand local property markets',
    text: `Access insights and data sourced from Northern Ireland's largest property portal to drive your investment strategy and decisions.`,
    headingSize: 24,
    headingMt: 25,
    headingMaxW: 220,
    textSize: 16,
    textMt: 15,
    maxW: 260,
  },
  {
    SVG: EaCalculator,
    heading: 'On and off market opportunities',
    text: `Our daily scanning of the market using specialised algorithms helps us identify assets that align with your acquisition strategies.`,
    headingSize: 24,
    headingMt: 25,
    headingMaxW: 230,
    textSize: 16,
    textMt: 15,
    maxW: 250,
  },
  {
    SVG: EaWhyTraffic,
    heading: 'Specialist expert advice',
    text: `Delivery of economic, geospatial and analytics solutions from industry experts.`,
    headingSize: 24,
    headingMt: 25,
    headingMaxW: 170,
    textSize: 16,
    textMt: 15,
    maxW: 230,
  },
];

const SpecialistConsultancyFeatures: React.FC = () => {
  const theme = useTheme();
  return (
    <>
      <ProductsPageHeader
        title="Specialist Consultancy"
        text="Our team of data specialists is ready to understand your business needs and provide bespoke data analysis reports to support your investment strategy and decisions"
        icons={icons}
        subHeadingProps={{ maxWidth: 970 }}
        icon={<EaConsultancy />}
        pb={100}
      />
      <FeaturesContainer>
        <FeaturesWrapper>
          <FeaturesSectionContainer gap={70}>
            <FeaturesSectionBgImage url={Mockup.src} bgPosition="10%" mobMaxW={450} />
            <Box maxWidth={450}>
              <FeaturesSectionTitle fontSize={22} mb={30}>
                A range of data solutions available to suit any need
              </FeaturesSectionTitle>
              <Text mb={25}>
                We understand the unique challenges and opportunities that you face in the property market. That&apos;s
                why we&apos;ve developed data solutions specifically designed to support your business objectives.
              </Text>
              <Text mb={25}>
                Our platform gathers and analyses property price, supply and demand data, providing you with a
                comprehensive view of the market and individual properties. With years of experience in data collection
                and analysis, we offer historical data, current market trends and predictive insights to empower your
                decision making process.
              </Text>
              <Text mb={45}>
                <Bold color={theme.primary}>Not sure exactly what you need?</Bold>
                <Bold>Our team are happy to support you find the right analysis based on your custom needs.</Bold>
              </Text>
              <ButtonContainer>
                <Button
                  containerStyle={{ maxWidth: '280px' }}
                  onClick={() => document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth' })}
                  testID="product-button"
                >
                  Contact us
                </Button>
              </ButtonContainer>
            </Box>
          </FeaturesSectionContainer>
        </FeaturesWrapper>
      </FeaturesContainer>
    </>
  );
};

export default SpecialistConsultancyFeatures;
